import React, {useState, useEffect} from 'react'
import cn from 'classnames'
import SpriteSvg from "../SpriteSvg/SpriteSvg";
import './Menu.scss'

function Menu ({
	handleNextPage,
	handleFullScreen,
	isRouteTraveled,
	gameEnded,
	isPlayMusic,
	setIsPlayMusic,
	startPage,
	mapPage,
	backpackPage,
	finalPage,
}){
	const [activeMenu, isActiveMenu] = useState(false)

	useEffect(()=> {

	},[isPlayMusic])

	return (
		<div className={cn(
					 'menu',
					 activeMenu && 'active',
			     gameEnded(isRouteTraveled) < 1 &&
			'disabled'
				 )}
		>
			<div className="menu-btn"  onClick={() => isActiveMenu(!activeMenu)}>
				{activeMenu &&
				<SpriteSvg width='24' height='24' id='menu-icon-cross'/>
				}
				{!activeMenu &&
					<SpriteSvg width='24' height='24' id='menu-icon'/>
				}
			</div>
			<div className={cn(
						 'inner-menu',
						 activeMenu && 'active'
					 )}
			>
				<div className="inner-menu-item" onClick={()=> handleNextPage(startPage)}>
					<p>Главная</p>
				</div>
				<a target='_blank' href='https://www.tn.ru/' className="inner-menu-item">
					<p>О компании</p>
				</a>
				<div onClick={()=> handleNextPage(finalPage)} className="inner-menu-item">
					<p>Получить календарь</p>
				</div>
			</div>

			<div className="menu-btn" onClick={handleFullScreen.enter}>
				<SpriteSvg width='24' height='24' id='fullscreen-icon'/>
			</div>

			<div className="menu-btn"  onClick={() => setIsPlayMusic(!isPlayMusic)}>
		  	{isPlayMusic === false && <SpriteSvg width='24' height='24' id='volume-off'/>}
				{isPlayMusic === true &&<SpriteSvg width='24' height='24' id='volume-icon'/>}
			</div>

			<div className={cn(
						 'menu-btn',
							gameEnded(isRouteTraveled) < 1 &&
						 'disabled'
					 )}
					 onClick={()=> handleNextPage(mapPage)}
			>
				<SpriteSvg width='24' height='24' id='route-icon'/>
			</div>

			<div className={cn(
				'menu-btn',
					gameEnded(isRouteTraveled) < 1 &&
					'disabled'
						)}
						 onClick={()=> handleNextPage(backpackPage)}
				>
				<SpriteSvg width='24' height='24' id='backpack-icon'/>
			</div>

		</div>
	)
}

export default Menu